import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LaborService } from "../labor.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-labor-detail-dialog',
  templateUrl: './labor-detail-dialog.component.html',
  styleUrls: ['./labor-detail-dialog.component.css']
})
export class LaborDetailDialogComponent implements OnInit {
  allData: any[];
  prodemand: any[];

  constructor(@Inject(MAT_DIALOG_DATA) public labor: any,
    public dialogRef: MatDialogRef<LaborDetailDialogComponent>,
    private laborService: LaborService,
    private router: Router
  ) {
    if (this.labor && this.labor.allData) {
      this.allData = JSON.parse(this.labor.allData);
    }

    if (this.labor && this.labor.prodemand) {
      this.prodemand = JSON.parse(this.labor.prodemand);
    }
  }

  ngOnInit() {
  }

  closeDialog(reloadPage: boolean): void {
    this.dialogRef.close(reloadPage);
  }

  confirm(): void {
    this.laborService.update(this.labor).subscribe(
      (response : any) => {
        console.log("closed");
        // this.closeDialog(true);
      },
      (error) => {
        console.error('Error updating labor:', error);
        this.closeDialog(true);
        // Handle error appropriately
      }
    );    
  }
}
